module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av336-853a3dcb98c5f03a365e07f8f15a9b7e.jpg";